import { createFileRoute } from "@tanstack/react-router";
import { TeamPage } from "@/pages/team/TeamPage";

export const Route = createFileRoute("/_angemeldet/_mitarbeiter/team")({
	component: TeamPage,
});
